<template>
  <div class="macAddress">
    <article>
      <h2 class="title">MAC地址</h2>
      <ul class="wrap">
        <li v-for="item in arr" :key= item.id class="input-mac">
         <el-input type="text" class="input" v-model="item.val" :maxlength="2" ref="input" @input="changeInput(item)" @blur="blurInput()"></el-input>
        </li>
      </ul>
      <p class="err" v-if="err_message">请输入数字或英文字符</p>
      <p class="err" v-if="err_info">请输入正确的MAC地址</p>
    </article>
  </div>
</template>
<script>

export default {
  data () {
    return {
      new_psd: "",
      arr: [      
        { fill: false, id: 0, val: "", ref:"input"},
        { fill: false, id: 1, val: "", ref:"input"},
        { fill: false, id: 2, val: "", ref:"input"},
        { fill: false, id: 3, val: "", ref:"input"},
        { fill: false, id: 4, val: "", ref:"input"},
        { fill: false, id: 5, val: "", ref:"input"}],
      err_info:false,
      err_message:false,
    };
  },
  created () {
  },
  mounted () {
    // 初始化错误提示
    this.err_info = false;
    this.err_message = false;
    //  input输入框获取焦点
    this.$refs.input[0].focus();
  },
  computed:{
    //  计算属性，获取6的输入框的内容，拼接成字符串
    macAddress () {
      let macAddress = "";
      this.arr.forEach((item,index)=>{
        macAddress = macAddress + item.val; 
      }); 
      return macAddress;
    }
  },
  props: {
  },
  methods: {
    changeInput (e) {
      if(e.val.length === 2 && e.id < 5){
        this.$refs.input[e.id + 1].focus();
      }
    },
    blurInput () {
      let regularExpression1 = /^[A-Za-z0-9]+$/;
      if(!(regularExpression1.test(this.macAddress))){
        this.err_message = true;
      }else{
        this.err_message = false;
      }
      if(this.macAddress.length === 12){
        this.err_info = false;
      }
    }
  },
  watch: {
  }
};
</script>
<style lang="less" scoped>
.macAddress{
  .title{
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    font-weight: bold;
  }
  .wrap{
    width:100%;
    height: 99px;
    padding-left: 0px;
    display: flex;
    justify-content:space-between;
    .input-mac{
      display: inline-block;
      width: 60px;
      height: 60px;
      position: relative;
      &:first-of-type{
      background-color: aqua;
        &::before{
          content:"";
        }
      }
      &::before{
        content:"：";
        display: block;
        width: 60px;
        height: 60px;
        line-height: 60px;
        font-size: 25px;
        font-weight: bold;
        position: absolute;
        right: 46px;
        text-align:center;
      }
      .input{
        /deep/.el-input__inner{
        width: 60px;
        height: 60px;
        text-align: center;
        font-size: 20px;
        color: #232323;
        background: linear-gradient(180deg, #eff3f5, #f6f7f9);
        border: 2px solid #a7acbd;
        box-shadow: inset 2px 2px 2px 0px #a7acbd, inset -2px -2px 2px 0px #a7acbd;
        outline: 0;
        border-radius: 5px;
        }
      }
    }
  }
  .err{
    color: red;
    font-size: 25px;
  }
}

</style>


// WEBPACK FOOTER //
// src/lib/ui/default/message/src/content/macAddress.vue